export const COLORS = [
  "#101C27",
  "#6200EE",
  "#EE5E0A",
  "#0A6919",
  "#0B84A4",
  "#F6C85F",
  "#6F4E7C",
  "#9CD867",
  "#D45087",
  "#8DDDD0",
  "#B80C09",
  "#6B2B06",
];
